import React from 'react';
import Spinner from './Spinner';
import { useGlobalSpinnerContext } from '../../Context/GlobalSpinnerContext';

const GlobalSpinner = () => {
  const isSpinnerOn = useGlobalSpinnerContext();

  return isSpinnerOn ? <Spinner /> : null;
};

export default GlobalSpinner;
